import { render } from "./banner-view.vue?vue&type=template&id=dd10c938&scoped=true&ts=true"
import script from "./banner-view.vue?vue&type=script&lang=ts"
export * from "./banner-view.vue?vue&type=script&lang=ts"

import "./banner-view.vue?vue&type=style&index=0&id=dd10c938&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd10c938"]])

export default __exports__